import { createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'

import { Style } from '@chegg-wt/core/types/styles-api'
import { ActionTypes } from './constants'

export const loadStyles = createStandardAction(ActionTypes.LOAD_STYLES)()

export const stylesRequested = createAction(
  ActionTypes.STYLES_REQUESTED,
  (action) => (query: string = '', page: number = 1) => action({ query, page })
)

export const stylesRequestSucceeded = createAction(
  ActionTypes.STYLES_FETCH_SUCCEEDED,
  (action) => (styles: Style[]) => action({ styles })
)

export const stylesRequestFailed = createErrorAction(ActionTypes.STYLES_FETCH_FAILED)
